var HorizontalDescription = require("app/ui/header/HorizontalDescription"),
    kind                  = require("enyo/kind");

module.exports = kind(/** @lends  app.MagazinePage.HorizontalDescription.prototype */ {

    /**
     * @private
     */
    name: "app.MagazinePage.HorizontalDescription",

    /**
     * @private
     */
    kind: HorizontalDescription,

    /**
     * @private
     */
    classes: "app-magazine-page-horizontal-description enyo-fit",

    /**
     * @protected
     */
    update: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            this.$.playMediaButton.hide();
        };
    })

});
